import { render, staticRenderFns } from "./information.vue?vue&type=template&id=441a117f&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=441a117f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441a117f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441a117f')) {
      api.createRecord('441a117f', component.options)
    } else {
      api.reload('441a117f', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=441a117f&scoped=true", function () {
      api.rerender('441a117f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/information.vue"
export default component.exports